window.ENVIRONMENT = HEALTHEX_INJECTED_ENVIRONMENT
